/* Netwerkloods — klantreis: keuzehulp-link, antwoorden-tab openen, alternatieven bij geen zoekresultaten. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var strings = theme.strings || {};

  /* ---------- Collectie: link 'Hulp bij kiezen' alleen tonen als er een keuzehulp is ---------- */
  function initAdviceLink() {
    var target = document.getElementById('Keuzehulp');
    document.querySelectorAll('[data-advice-link]').forEach(function (link) {
      link.hidden = !target;
    });
  }

  /* ---------- Productpagina: 'Past dit bij mij?' opent de juiste tab ---------- */
  function openPanelFor(id, instant) {
    var el = document.getElementById(id);
    if (!el) return false;
    var panel = el.closest('[role="tabpanel"]');
    var tabs = panel && panel.closest('product-tabs');
    if (panel && tabs && typeof tabs.select === 'function') {
      var tab = document.getElementById(panel.getAttribute('aria-labelledby'));
      var index = tabs.tabs ? tabs.tabs.indexOf(tab) : -1;
      if (index > -1) tabs.select(index, false);
    }
    // Scroll naar de tabbalk (niet naar het paneel), net onder de meescrollende header.
    var target = tabs || panel || el;
    var header = document.querySelector('.section-site-header');
    var offset = 16;
    if (header && getComputedStyle(header).position === 'sticky') offset += header.getBoundingClientRect().height;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduce || instant ? 'auto' : 'smooth' });
    var focusTarget = panel || el;
    focusTarget.focus({ preventScroll: true });
    return true;
  }

  function initAnswersLink() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-answers-link]');
      if (!link) return;
      var id = (link.getAttribute('href') || '').replace(/^#/, '');
      if (id && openPanelFor(id)) e.preventDefault();
    });
    if (window.location.hash === '#ProductAnswers') {
      // De browser springt zelf ook naar het anker (tot de pagina geladen is); daarna opnieuw goed zetten.
      var openFromHash = function () { setTimeout(function () { openPanelFor('ProductAnswers', true); }, 100); };
      if (document.readyState === 'complete') openFromHash();
      else window.addEventListener('load', openFromHash, { once: true });
    }
  }

  /* ---------- Zoekpagina: alternatieve schrijfwijzen van een modelnummer proberen ---------- */
  function initSearchAlternatives() {
    var box = document.querySelector('[data-search-alternatives]');
    if (!box || typeof theme.modelAlternatives !== 'function' || !theme.routes) return;
    var terms = box.getAttribute('data-terms') || '';
    var alternatives = theme.modelAlternatives(terms);
    if (!alternatives.length) return;

    function suggest(q) {
      var url = theme.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last';
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          return { q: q, products: products };
        });
    }

    (function next(i) {
      if (i >= alternatives.length) return;
      suggest(alternatives[i])
        .then(function (res) {
          if (!res.products.length) return next(i + 1);
          render(res);
        })
        .catch(function () {});
    })(0);

    function render(res) {
      box.innerHTML = '';
      var p = document.createElement('p');
      p.className = 'search-alternatives__title';
      p.textContent = (strings.searchDidYouMean || '').replace('[terms]', res.q);
      box.appendChild(p);
      var ul = document.createElement('ul');
      ul.className = 'search-alternatives__list';
      ul.setAttribute('role', 'list');
      res.products.forEach(function (product) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = product.url;
        a.className = 'search-alternatives__item';
        a.textContent = product.title;
        li.appendChild(a);
        ul.appendChild(li);
      });
      box.appendChild(ul);
      var all = document.createElement('a');
      all.className = 'link';
      all.href = theme.routes.search + '?q=' + encodeURIComponent(res.q) + '&options%5Bprefix%5D=last';
      all.textContent = (strings.searchViewAllFor || '').replace('[terms]', res.q);
      box.appendChild(all);
      box.hidden = false;
    }
  }

  /* ---------- Winkelwagen: zakelijke bestelgegevens direct opslaan als winkelwagenkenmerken ---------- */
  function initCartAttributes() {
    var timers = {};
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-attribute]');
      if (!input || !theme.routes) return;
      var match = /^attributes\[(.+)\]$/.exec(input.name);
      if (!match) return;
      var key = match[1];
      var status = document.querySelector('[data-cart-attribute-status]');
      clearTimeout(timers[key]);
      timers[key] = setTimeout(function () {
        var attributes = {};
        attributes[key] = input.value.trim();
        fetch(theme.routes.cart + '/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        })
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            if (status) status.textContent = strings.cartAttributeSaved || '';
          })
          .catch(function () {
            if (status) status.textContent = strings.cartAttributeError || '';
          });
      }, 300);
    });
  }

  function init() {
    initCartAttributes();
    initAdviceLink();
    initAnswersLink();
    initSearchAlternatives();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', initAdviceLink);
})();
